import React from 'react';

interface IProps {
    onClick: () => void;
    zIndex?: number;
}

const Backdrop = ({ onClick, zIndex }: IProps) => (
  <div id='backdrop' role='presentation' onClick={onClick} className='fixed top-0 left-0 w-screen h-screen opacity-0' style={{ zIndex: zIndex || 0 }} />
);

export default Backdrop;
